import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { SearchEmployeeDialogService } from 'src/app/services/Non-Master/SearchEmployeeDialog.service';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { tEmployeeModel, tEmployeeWithTypeModel } from 'src/app/models/tEmployeeModel';
import { tEmployeeService } from 'src/app/services/tEmployee.service';
import { isNullOrUndefined } from 'util';
import { tVendorModel } from 'src/app/models/tVendorModel';
import { tVendorService } from 'src/app/services/tVendor.service';


@Component({
  selector: 'app-search-vendor-dialog',
  templateUrl: './search-vendor-dialog.component.html',
  styleUrls: ['./search-vendor-dialog.component.css']
})
export class SearchVendorDialogComponent implements OnInit {

  TAG = 'SearchVendorDialogComponent';

  editForm: FormGroup;

  @Input() actionCase: number;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  dataSource: MatTableDataSource<tVendorModel>;
  checkLoadingDataSource: any;
  dataList: tVendorModel[];



  displayedColumns: string[] = [
    // 'action_button_title',

    'vendorCode',
    'vendorNameAll',

   // 'vendorPayterm',
   // 'vendorAddressAll',
   'shortCode',
    'vendorTel',
    'vendorContact',
    // 'vendorEmail',
    // 'vendorFax',
    // 'vendorRemark1',
    // 'vendorRemark2'
  ];


  constructor(
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    private router: Router,
    private formBuilder: FormBuilder,
    private tVendorService: tVendorService,
  ) { }

  generalFilter = new FormControl();
  filteredValues = {
    mediCode: '', mediName: '', mediNameEng: '', mediBarCode: ''
  };

  //loading spinner
  isLoading = true;


  ngOnInit() {
    this.getAllData();
  }

  getAllData(): void {
    this.log.i(this.TAG, ' getAllProducts');

    this.tVendorService.getAllData().subscribe(data => {
      //  this.dataList = data;

      this.dataSource = new MatTableDataSource<tVendorModel>(data);
      this.dataSource.paginator = this.paginator;

      //loading spinner
      this.isLoading = false;
      this.checkLoadingDataSource = data;
      //table sort
      this.dataSource.sort = this.sort;


      this.generalFilter.valueChanges.subscribe((generalFilterValue) => {
        this.filteredValues['vendorName'] = generalFilterValue;
        this.filteredValues['vendorNameEng'] = generalFilterValue;
        this.dataSource.filter = JSON.stringify(this.filteredValues);
      });

      this.dataSource.filterPredicate = this.customFilterPredicate();

    });
  }

  customFilterPredicate() {
    const myFilterPredicate = (data: tVendorModel, filter: string): boolean => {

      let searchString = JSON.parse(filter);

      return (searchString.vendorName.toLowerCase() == '' || 
      (data.vendorName != null 
        && data.vendorName.toString().trim().toLowerCase().indexOf(searchString.vendorName.toLowerCase()) !== -1))
      || 
      (searchString.vendorNameEng.toLowerCase() == '' || 
      (data.vendorNameEng != null 
        && data.vendorNameEng.toString().trim().toLowerCase().indexOf(searchString.vendorNameEng.toLowerCase()) !== -1))
        ;

    }

    return myFilterPredicate;
  }


  selectedRecord(selectedModel: tVendorModel) {
    this.log.i(this.TAG, 'selectedRecord data = ' + selectedModel.vendorName);


    this.activeModal.close(selectedModel);

  }

}
